export const version = 'kunde-b60cb1b9c5daf31b9d085e035cde9805ed8c6410';